import React from 'react';
import { Box, Button } from '@mui/material'; 
import PropTypes from 'prop-types';
import './styles.css';
import FooterPage from './FooterPage'; 


const Login = ({ onLogin }) => {
  const handleLogin = () => {
    onLogin();
  };

  return (
    <Box className="login-box">
    <div className= "container">
      <p className="popup-description" id="popup-description">
        Register Your GM Energy Product
      </p>
      <p className="popup-message" id="popip-message">
      Please log in or sign up with the GM account you want to use for your GM Energy product registration.
      </p>
      <div className="login-button">
        <Button
          variant="contained"
          color="primary"
          onClick={handleLogin}
        >
          Log in / Sign up
        </Button>
      </div>
    </div>
    <FooterPage />
    </Box>
  );
};

Login.propTypes = {
  onLogin: PropTypes.func.isRequired,
};

export default Login;